import { useControls } from 'react-zoom-pan-pinch'
import getSteppedZoom, { ZoomDirection } from './getSteppedZoom'

interface IUseSteppedZoomControls {
  step: number
  minZoom: number
  maxZoom: number
}

/** Zoom em degraus de `step`, para os botões e os atalhos. Deve ser usado dentro do `TransformWrapper`. */
const useSteppedZoomControls = ({
  step,
  minZoom,
  maxZoom
}: IUseSteppedZoomControls) => {
  const { instance, zoomIn, zoomOut } = useControls()

  const zoomBy = (direction: ZoomDirection) => {
    const { scale } = instance.state
    const target = getSteppedZoom(scale, direction, step, minZoom, maxZoom)
    if (target === scale) return
    if (direction === 'in') void zoomIn(target - scale)
    else void zoomOut(scale - target)
  }

  return {
    zoomIn: () => zoomBy('in'),
    zoomOut: () => zoomBy('out')
  }
}

export default useSteppedZoomControls
